module.exports = __webpack_public_path__ + "img/emc2.f3500488.svg";